import {AppError} from '../core/AppError';
import SessionStorage from './storage/SessionStorage';
import LocalStorage from './storage/LocalStorage';

class StorageDataService {
    constructor(props) {
        const {fieldName, storageType} = props;
        switch (storageType) {
            case 'sessionStorage':
                this.storage = new SessionStorage();
                break;
            case 'localStorage':
                this.storage = new LocalStorage();
                break;
            default:
                throw new AppError('Не найден способ хранения информации.');
        }
        this.fieldName = fieldName;
        this.checkEnvironment();
    }

    checkEnvironment() {
        this.storage.check();
    }

    get() {
        const valuesJson = this.storage.get(this.fieldName);
        return valuesJson ? JSON.parse(valuesJson) : undefined;
    }

    save(values) {
        this.storage.set(this.fieldName, JSON.stringify(values));
    }

    delete() {
        this.storage.remove(this.fieldName);
    }
}

export default StorageDataService;
